import { z } from 'zod'

export const CompanyApiTokenDTO = z.object({
  token: z.string().nullish()
})

export type CompanyApiTokenDTO = z.infer<typeof CompanyApiTokenDTO>

export function mapCompanyApiTokenToDTO (model: string): CompanyApiTokenDTO {
  return {
    token: model
  }
}

export function mapDTOToCompanyApiToken (dto: CompanyApiTokenDTO): string {
  return dto.token ?? ''
}
